import { Component, OnInit, ViewChildren, QueryList, ViewChild } from '@angular/core';
import { MatPaginator, MatTableDataSource, MatSort } from '@angular/material';
import { APITemplateService } from '../../_services/template/API-template';
import { APILoginService } from '../../_services/login/API-login';
import { $ModalManagerService } from '../../../../_helpers/Modals/ModalManager.service';
import { Constants } from '../../../../_utils/Constants';
import { $DBManagerService } from '../../../../_helpers/DB/DBManager.service';
import { formatDate } from '@angular/common';
import { $BroadcastManagerService } from '../../../../_helpers/BroadcastManager.service';
import { BehaviorSubject } from "rxjs/BehaviorSubject";
import { DataSource } from '@angular/cdk/table';
import { Observable } from 'rxjs/Observable';
import { map } from 'rxjs/operators';
import { style } from '@angular/animations';
import { MyDialogComponent } from '../../../../_helpers/Modals/my-dialog/my-dialog.component';
import { EntityDialogComponent } from '../../../../_helpers/Modals/entity-dialog/entity-dialog.component';
import { FormBuilder, Validators, FormGroup, FormControl, FormArray } from '@angular/forms';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import * as CryptoJS from 'crypto-js';
import { saveAs as importedSaveAs } from "file-saver";
import { Router, ActivatedRoute } from '@angular/router';    //cstlinkdelinkfn



const now = new Date();
const time_today = now.getTime();
const formatTime = formatDate(time_today, 'HH:mm', 'en-US', '+0530');
const currentdat = formatDate(now, 'dd-MM-yyyy', 'en-US', '+0530');
//console.log("formatTime -- : ", formatTime);
//console.log("datecur :",  currentdat);
export interface DialogData {
  setValue: string,
  setRole: string
}



@Component({
  selector: 'app-templates-by-pe',
  templateUrl: './templates-by-pe.component.html',
  styleUrls: ['./templates-by-pe.component.css']
})
export class TemplatesByPEComponent implements OnInit {
  maxDate: Date = new Date();

  deactvResult: any;
  fileDownload: any = [];
  newEntities: number[] = [];
  newSummaries: number[] = [];
  entity: any = [];
  data: any = {};

  entitySummary: any = [];
  modelTest: any;
  entityId: any;
  filterData: any;
  show: boolean = false;
  statusMongo: String;
  dataSource: MatTableDataSource<any>;
  dataSource1: MatTableDataSource<any>;
  dataSource2: MatTableDataSource<any>;
  noRecord: any;
  noRecord1: any;
  noRecord2: any;
  refNos = "";
  emailids = "";
  Entity_EmailID: any;
  //sts: any;
  Template_Status: any;
  showDropdown: boolean = false
  showStatusDropdown: boolean = false
  islink: boolean = true     //cstlinkdelinkfn

  //model class
  //model=new (null,null,null,null);

  //Error Display
  isValidDate: any;
  verifyTemplate: any = {};
  verifyTemplateKey: any = {};
  minLen: boolean = false;
  maxLen: boolean = false;
  specialChar: boolean = false;
  // justification: any ={};
  error: any = { isError: false, errorMessage: "" };
  VerificationSts = [
    { id: 'empty', sts: '' },
    { id: 'yes', sts: 'Yes' },
    { id: 'no', sts: 'No' },

  ];
  disableread: boolean[] = [];
  prevURN: any = ''
  default: any = 'empty'

  @ViewChildren(MatPaginator) paginator = new QueryList<MatPaginator>();
  @ViewChild('t1Sort') t1Sort: MatSort;
  @ViewChild('t2Sort') t2Sort: MatSort;
  @ViewChild('t3Sort') t3Sort: MatSort;


  dataSubject = new BehaviorSubject<any[]>([]);
  displayedColumns: string[] = ['Template_Ref_No', 'Template_ID', 'Template_Header', 'Template_Name', 'Content_Type', 'Template_Variables', 'Verify', 'Verify_timestamp', 'reason', 'Verification', 'Template_CommunicationType', 'Template_Category', 'Template_Status', 'CSTempID', 'createdAt', 'Modify'];
  // displayedColumns1: string[] = ['Reference No.', 'Entity Type', 'Entity Role', 'Name', 'Address', 'Documents','Download', 'Approve', 'Reject'];

  displayedColumns1: any[] = ['Verify', 'Verify_timestamp', 'Template_Ref_No', 'Content_Type', 'Template_Header', 'Entity_ID', 'T_Created_Date', 'T_Updated_By', 'Template_Name', 'reason',
    'Template_Content', 'Template_CommunicationType', 'Content_Type', 'Template_Status'];

  displayedColumns2: string[] = ['Template_Ref_No', 'RejectedAt', 'Entity_Role', 'Entity_Name', 'Entity_EmailID', 'Entity_Addr', 'Entity_Status'];
  entityRole = this.db.get(Constants.SESSSION_STORAGE, Constants.ENTITY_ROLE);
  deactivate = [];
  // Entity_Role_Approved: any;
  fetchedData: any;
  EntityDetails: any;
  industry_type: any;
  industry_category: any;
  sector: any;
  entity_name: any;
  temp_var: any;

  VerificationStsForm: FormGroup;
  VerificationReasonForm: FormGroup;
  reasonArray: any;



  getDisplayedColumns(): string[] {

    const isMobile = this.entityRole != 'Application Adminstrator';
    let a = this.displayedColumns1
      .filter(cd => !isMobile || cd['showMobile'] !== false)
      .map(cd => typeof cd === 'string' ? cd : cd.def);

    return a;
  }



  form1: any = {};
  form2: any = {};

  constructor(
    private es: APITemplateService,
    private ls: APILoginService,
    private $modal: $ModalManagerService,
    private db: $DBManagerService,
    private fb: FormBuilder,
    public dialog: MatDialog,
    private router: Router, //cstlinkdelinkfn
    private $: $BroadcastManagerService) { }

  ngOnInit() {
    //tmpverification Changes starts


    //tmpverification Changes ends
    this.getEntityDetails();
    this.APIgetTemplateSummary();

    //console.log("entity role is", this.entityRole)

    this.modelTest = this.$modal;
    this.entityId = this.db.get(Constants.SESSSION_STORAGE, Constants.ENTITY_ID);
    this.Entity_EmailID = this.db.get(Constants.SESSSION_STORAGE, Constants.Entity_EmailID);
    this.maxDate.setDate(new Date().getDate());

    this.VerificationStsForm = this.fb.group({

      VerificationStsArray: this.fb.array([])
    })

    //  this.VerificationStsForm = new FormGroup({

    //   'VerificationStsArray': new FormArray([

    //     new FormControl(null,Validators.required) ])

    //  }) 


    this.default = "empty"

    // this.VerificationReasonForm = this.fb.group({
    //       VerificationReason: this.fb.array([['', [Validators.pattern(/^(?:[a-zA-Z0-9\s]+)?$/)]],
    //       ['', [Validators.pattern(/^(?:[a-zA-Z0-9\s]+)?$/)]],
    //       ['', [Validators.pattern(/^(?:[a-zA-Z0-9\s]+)?$/)]],
    //       ['', [Validators.pattern(/^(?:[a-zA-Z0-9\s]+)?$/)]],
    //       ['', [Validators.pattern(/^(?:[a-zA-Z0-9\s]+)?$/)]]])
    //    })
    // }
    this.VerificationReasonForm = this.fb.group({
      VerificationReason: this.fb.array([])
    })
  }
  reset() {
    this.verifyTemplate = {};
    this.verifyTemplateKey = {};
    this.data = {};
    this.data['Entity_ID'] = this.entityId

    // this.form1.searchBy1 = null
    this.form1 = {};
    this.APIgetTemplateSummary();
    this.showDropdown = false;
    this.showStatusDropdown = false;
    //console.log("first reset function");

  }

  showCSTinfo(name, content) {
    this.$modal.promptModal({
      title: "Consent Template Name: " + name,
      msg: "Consent Template Content: " + content
    });
  }



  openDropdown(value) {
    //console.log("value", value)
    if (value == "Communication Type") {
      this.showDropdown = true;
      this.showStatusDropdown = false;
    }


    else if (value == "Status") {
      this.showStatusDropdown = true;
      this.showDropdown = false;
    }
    else {
      this.showDropdown = false;
      this.showStatusDropdown = false;
    }
    //console.log("value", value)

  }

  listvalue(event) {
    if (event) {
      this.form1.searchBy = "Communication Type"
    }
  }



  //modify dialog



  onSubmitFilter(filterForm) {

    // console.log(filterForm.value);
    var fdate = filterForm.startDate;
    var ldate = filterForm.endDate;
    var cdate = filterForm.currentDate;
    cdate = formatDate(Date.now(), 'yyyy-MM-dd', 'en-US', '+0530');

    if (typeof fdate === 'undefined' || fdate == null)
      fdate = "";
    else
      fdate = formatDate(filterForm.startDate, 'yyyy-MM-dd', 'en-US', '+0530');
    if (typeof ldate === 'undefined' || ldate == null)
      ldate = "";
    else
      ldate = formatDate(filterForm.endDate, 'yyyy-MM-dd', 'en-US', '+0530');
    var param = filterForm.search


    if (typeof param === 'undefined' || param == null)
      param = "";

    // console.log("fdate", fdate);
    // console.log("ldate", ldate, "param", param);
    var filterType
    if (filterForm.searchBy)
      filterType = filterForm.searchBy;
    if (filterForm.searchBy1)
      filterType = filterForm.searchBy1;
    if (filterForm.searchBy2)
      filterType = filterForm.searchBy2;

    var difference_in_Time = new Date(ldate).getTime() - new Date(fdate).getTime()
    var difference_in_Days = difference_in_Time / (1000 * 3600 * 24)
    //console.log("difference_in_Timedifference_in_Time in days", difference_in_Time)



    if (fdate != "" && ldate == "") {
      ldate = cdate
    }



    this.data = {

      "Start_Date": fdate,
      "End_Date": ldate,
      "filterType": filterType,

      "URN": param,
      "TemplateName": param,
      "Header": param,

      //   "Entity_ID":this.db.get(Constants.SESSSION_STORAGE, Constants.ENTITY_ID),

    }
    if (filterType == "Promotional") {
      this.data['Promotional'] = "Promotional"
    }
    else if (filterType == "Transactional") {
      this.data['Transactional'] = "Transactional"
    }
    else if (filterType == "Service Explicit") {
      this.data['ServiceExplicit'] = "Service Explicit"
    }
    else if (filterType == "Service Implicit") {
      this.data['ServiceImplicit'] = "Service Implicit"
    }
    else if (filterType == "C") {
      this.data['Template_Status'] = "C"
    }
    else if (filterType == "R") {
      this.data['Template_Status'] = "R"
    }
    else if (filterType == "A") {
      this.data['Template_Status'] = "A"
    } else if (filterType == "IR") {
      this.data['Template_Status'] = "IR"
    }

    if (fdate == "" && ldate == "" && (filterType == null || filterType == "") && param == "") {
      this.$modal.errorModal({
        title: 'Error',
        msg: 'Please select any option'
      });
    }
    else if (fdate == "" && ldate != "") {
      this.$modal.errorModal({
        title: 'Error',
        msg: 'Please select Start date'
      });
    }
    else if (fdate > ldate) {
      this.$modal.errorModal({
        title: 'Error',
        msg: 'From Date cannot be after To Date'
      });
    }

    else if (fdate != "" && ldate != "" && difference_in_Days > 30) {
      this.$modal.errorModal({
        title: 'Error',
        msg: 'Date Difference should not be more than 30 days'
      });
    }
    // else if ((filterType != null && filterType != "") && (param == null || param=="")) {

    //   this.$modal.errorModal({
    //     title: 'Error',
    //     msg: 'Please enter '+ filterType+' value'
    //   });
    // }
    else {
      this.data['Entity_ID'] = this.entityId
      this.es.getTemplateSummaryFilter(this.data)
        .subscribe(r => {

          this.fetchedData = JSON.stringify(r.Data);
          this.dataSource = r.Data;
          this.onChangeDataSource(r.Data);
        });
    }
  }

  //tmpverification Changes starts
  get h() { return this.VerificationReasonForm.controls; }


  onKey(event: any, urn: any, vars: any, j: any) {
    // console.log(" reason ", event.target.value, urn, vars)
    // let json = {}
    // json["urn"] = urn
    // json["reason"] = event.target.value
    // json["vars"] = vars
    if (event.target.value !== "") {
      this.verifyTemplateKey["urn"] = urn;
      this.verifyTemplateKey["reason"] = event.target.value
      this.verifyTemplateKey["vars"] = vars;
    }

    if (parseInt(vars) > 2) {
      //console.log("var > 2 loop ")
      this.VerificationReasonForm.controls.VerificationReason.get(j.toString()).setValidators([Validators.required, Validators.minLength(10), Validators.maxLength(100), Validators.pattern(/^(?:[a-zA-Z0-9\s]+)?$/)])
      this.VerificationReasonForm.controls.VerificationReason.get(j.toString()).updateValueAndValidity()

    }


  }


  selected(tempsts: any, verifydue: any, urn: any, event: any, varcount: any, frmctrnme: any) {

    //console.log("VaLUE ***** ", event, urn, varcount,frmctrnme)
    if ((verifydue == "yes" && tempsts == "A") || (verifydue == "NA" && tempsts == "A") || tempsts == "SC" || tempsts == "SV" || tempsts == "SU") {
      console.log("Is t cmng here ")
      this.disableread[urn] = false;
    }
    else {
      this.disableread[urn] = true;
    }
    if (event !== "empty") {
      this.disableread[urn] = false;
      this.verifyTemplate["urn"] = urn
      this.verifyTemplate["sts"] = event
      this.verifyTemplate["vars"] = varcount
      this.prevURN = urn
      this.VerificationReasonForm.controls.VerificationReason.get(frmctrnme.toString()).setValue("");
      // console.log(" this.VerificationReasonForm.controls.VerificationReason.get(formctrlname) ", this.VerificationReasonForm.controls.VerificationReason.get(frmctrnme.toString()))
    }
    else {
      this.$modal.errorModal({
        title: 'Header Verification',
        msg: "Blank is not allowed for Verify field"
      });
    }

  }

  verifyTemplates(urn, templateid) {


    let finalTempInput: any = {}
    // if (this.verifyTemplate.sts == undefined) {
    //   this.$modal.errorModal({
    //     title: 'Template Verification',
    //     msg: "Please select/change verification status"
    //   });
    // }
    if (this.verifyTemplate.sts == undefined) {
      finalTempInput = { "urn": urn, "sts": "NA", "reason": this.verifyTemplateKey.reason, templateId: templateid }
    }
    else if (this.verifyTemplate.urn !== urn) {
      this.$modal.errorModal({
        title: 'Template Verification',
        msg: "Please select/change verification status corresponding to the verify button"
      });
    }

    if (this.verifyTemplate.urn == urn && this.verifyTemplate.vars <= 2) {
      //var less than 2

      if (Object.keys(this.verifyTemplateKey).length > 0) {

        if (this.verifyTemplateKey.urn == urn && this.verifyTemplateKey.reason) {

          finalTempInput = { "urn": urn, "sts": this.verifyTemplate.sts, "reason": this.verifyTemplateKey.reason, "templateId": templateid }
        }
        // else if(this.verifyTemplateKey.urn == urn && !this.verifyTemplateKey.reason){
        //   console.log("1st if, if esle if")
        //   finalTempInput = {"urn":urn,"sts":this.verifyTemplate.sts,"reason":""}
        // }
      }
      else {
        if (!this.verifyTemplate.reason) {

          finalTempInput = { "urn": urn, "sts": this.verifyTemplate.sts, "reason": "", "templateId": templateid }
        }
        // console.log("1st if, if else")
        // this.$modal.errorModal({
        //   title: 'Template Verification',
        //   msg: "Justification is mandatory"
        // });
      }
    }
    else if (this.verifyTemplate.urn == urn && this.verifyTemplate.vars > 2) {

      if (Object.keys(this.verifyTemplateKey).length > 0) {
        if (this.verifyTemplateKey.urn == urn && this.verifyTemplateKey.reason) {
          if (this.verifyTemplateKey.reason.length < 10) {
            this.minLen = true
            return
          }
          else if (this.verifyTemplateKey.reason.length > 100) {
            this.maxLen = true;
            return
          }
          else if (/^(?:[a-zA-Z0-9\s]+)?$/.test(this.verifyTemplateKey.reason) !== true) {
            this.specialChar = true
            return
          }
          else {
            finalTempInput = { "urn": urn, "sts": this.verifyTemplate.sts, "reason": this.verifyTemplateKey.reason, "templateId": templateid }
          }
        }
      }
      else {
        this.$modal.errorModal({
          title: 'Template Verification',
          msg: "Justification is mandatory"
        });
      }
    }
    // console.log("finalTempInput ", finalTempInput)
    if (Object.keys(finalTempInput).length > 0) {

      let inputjson = {
        "jsonString": finalTempInput
      }

      this.es.verifyTemplates(inputjson)
        .subscribe(r => {
          //  console.log("response ", r)
          if (r.status == "ok") {
            this.verifyTemplateKey = [];
            this.verifyTemplate = [];
            finalTempInput = [];
            this.APIgetTemplateSummary()
            this.$modal.successModal({
              title: 'Template Verification',
              msg: 'Template verification has been completed succesfully!'
            });
          }
          else {
            this.$modal.errorModal({
              title: 'Template Verification',
              msg: r.message
            });
          }
        });
    }
    return

  }

  //tmpverification Changes ends

  //cstlinkdelinkfn

  linkFn(CSTempID, commtype, Refno) {

    if (CSTempID != "")
      this.islink = false
    else
      this.islink = true
    //to convert urn to tempid
    // console.log("------------------------islink-------------", this.islink);
    // console.log("------------------------CSTempID-------------", CSTempID);
    var str1 = new String("1607");
    var str2 = new String(Refno);
    var TempID = str1.concat(str2.toString());

    this.db.set(Constants.SESSSION_STORAGE, Constants.ENTITY_ID, this.entityId);
    this.db.set(Constants.SESSSION_STORAGE, Constants.CONSENTTEMPLATEID, CSTempID);
    this.db.set(Constants.SESSSION_STORAGE, Constants.MODEOFCOMMUNICATION, commtype);
    this.db.set(Constants.SESSSION_STORAGE, Constants.TM_ID, TempID);
    this.db.set(Constants.SESSSION_STORAGE, Constants.CSTLINKDELINK, this.islink);

    this.router.navigate(['linking_consent']);
  }


  APIgetTemplateSummary() {
    let eId = this.db.get(Constants.SESSSION_STORAGE, Constants.ENTITY_ID);
    var query = {
      "Template_Status": { $in: ["A", "IR", "C", "CR", "R", "SC", "SV", "SU", "B", "I"] },
      Entity_ID: eId,
    }
    // console.log("unapproved status", query)
    this.es.getTemplateSummaryMongo(query)
      .subscribe(r => {
        // console.log("summary ----------------  ", r)
        this.entity = r;
        this.onChangeDataSource(this.entity);
        if (r.message == "success") {
          this.$modal.successModal({
            title: 'Entity Registration',
            msg: 'Entity has been Approved'
          });
        }
      });

  }


  // getServerData(data){


  // }

  onChangeDataSource(value) {
    //tmpverification Changes starts
    for (let i = 0; i < value.length; i++) {
      this.disableread[value[i].Template_Ref_No] = true;
      //Added for suspension
      if (value[i].Template_Status == "SC" || value[i].Template_Status == "SV" || value[i].Template_Status == "SU" || (value[i].Template_Status == "A" && value[i].tmpverificationDue == "yes")) {
        //console.log("--- ",value[i].Template_Ref_No)
        this.disableread[value[i].Template_Ref_No] = false;
      }
      //console.log("disableread in datasrc ",this.disableread)
      if (value[i].Template_Status == "A" && value[i].Template_Variables > 2) {
        if (value[i].tmpVerificationStatus && value[i].tmpVerficationReason) {
          (<FormArray>this.VerificationStsForm.controls['VerificationStsArray']).push(this.fb.control('', []))
          // console.log(value[i].cli, " i ", i, "val[i].tmpStatus ", value[i].tmpVerificationStatus, " vae[i].tmpReason ", value[i].tmpVerficationReason)
          this.VerificationStsForm.controls.VerificationStsArray.get(i.toString()).setValue(value[i].tmpVerificationStatus);
          (<FormArray>this.VerificationReasonForm.controls['VerificationReason']).push(this.fb.control('', [Validators.required, Validators.minLength(10), Validators.maxLength(100), Validators.pattern(/^(?:[a-zA-Z0-9\s]+)?$/)]))
          this.VerificationReasonForm.controls.VerificationReason.get(i.toString()).setValue(value[i].tmpVerficationReason);
        }
        else {
          (<FormArray>this.VerificationReasonForm.controls['VerificationReason']).push(this.fb.control('', [Validators.required, Validators.minLength(10), Validators.maxLength(100), Validators.pattern(/^(?:[a-zA-Z0-9\s]+)?$/)]))
          let selectests;
          (<FormArray>this.VerificationStsForm.controls['VerificationStsArray']).push(this.fb.control('', []))
          this.VerificationStsForm.controls.VerificationStsArray.get(i.toString()).setValue("empty");
        }

      }
      else {
        (<FormArray>this.VerificationReasonForm.controls['VerificationReason']).push(this.fb.control('', []))
        this.VerificationReasonForm.controls.VerificationReason.get(i.toString()).setValue(value[i].tmpVerficationReason);
        let selectests;
        (<FormArray>this.VerificationStsForm.controls['VerificationStsArray']).push(this.fb.control('', []))
        this.VerificationStsForm.controls.VerificationStsArray.get(i.toString()).setValue(value[i].tmpVerificationStatus);
      }
      // console.log(value[i])
      //  if(value[i].Template_Status == "A" && value[i].tmpVerificationStatus){
      //      this.VerificationStsForm.controls.VerificationStsArray.get(i.toString()).setValue(value[i].tmpVerificationStatus);
      //      this.VerificationReasonForm.controls.VerificationReason.get(i.toString()).setValue(value[i].tmpVerficationReason);

      //  }
    }
    //   //tmpverification Changes ends
    this.dataSource = new MatTableDataSource(value);
    //this.dataSource.paginator = this.paginator;
    this.dataSource.paginator = this.paginator.toArray()[0];
    this.dataSource.sort = this.t1Sort;
    //this.dataSource.sort = this.t2Sort;
    this.noRecord = this.dataSource.connect().pipe(map(data => data.length === 0));
  }


  downloadTemplates(filterForm) {

    // console.log(filterForm.value);

    var fdate = filterForm.startDate;
    var ldate = filterForm.endDate;
    var cdate = filterForm.currentDate;
    cdate = formatDate(Date.now(), 'yyyy-MM-dd', 'en-US', '+0530');

    if (typeof fdate === 'undefined' || fdate == null)
      fdate = "";
    else
      fdate = formatDate(filterForm.startDate, 'yyyy-MM-dd', 'en-US', '+0530');
    if (typeof ldate === 'undefined' || ldate == null)
      ldate = "";
    else
      ldate = formatDate(filterForm.endDate, 'yyyy-MM-dd', 'en-US', '+0530');
    var param = filterForm.search


    if (typeof param === 'undefined' || param == null)
      param = "";
    // else
    //   param = filterForm.search.replace(/\s/g,"");

    // console.log("fdate", fdate);
    // console.log("ldate", ldate, "param", param);
    var filterType
    if (filterForm.searchBy)
      filterType = filterForm.searchBy;
    if (filterForm.searchBy1)
      filterType = filterForm.searchBy1;
    if (filterForm.searchBy2)
      filterType = filterForm.searchBy2;

    var difference_in_Time = new Date(ldate).getTime() - new Date(fdate).getTime()
    var difference_in_Days = difference_in_Time / (1000 * 3600 * 24)
    // console.log("difference_in_Timedifference_in_Time in days", difference_in_Time)


    if (fdate != "" && ldate == "") {
      ldate = cdate
    }




    if ((filterType == "URN" || filterType == "Template Name" || filterType == "Header") && !param)
      alert("Please enter Search Parameter")
    else if (fdate != "" && ldate != "" && difference_in_Days > 30) {
      alert("Date Difference should not be more than 30 days")
    }

    else if (fdate > ldate) {
      alert("From Date cannot be after To Date")
    }

    else if (fdate == "" && ldate != "") {
      alert("Please select Start date")
    }


    else {


      var fileName;
      const currentdat = formatDate(now, 'medium', 'en-US', '+0530');
      this.data['Entity_ID'] = this.entityId

      this.es.downloadTemplates(this.data).subscribe(r => {
        fileName = currentdat + ' Templates.xlsx';
        importedSaveAs(r, fileName)
        this.$modal.successModal({
          title: 'Templates',
          msg: 'File has been downloaded Successfully'
        });
      })
    }
  }
  getEntityDetails() {
    let data = {
      "entity_id": this.db.get(Constants.SESSSION_STORAGE, Constants.ENTITY_ID),
    }
    this.es.getContentEntityDetails(data)
      .subscribe(r => {
        try {


          if (r[0].etype === 'P') {
            this.industry_type = "Private";

          }
          else if (r[0].etype == 'G') {
            this.industry_type = "Government";
          }
          else if (r[0].etype == 'S') {
            this.industry_type = "SEBI";
          }
          else if (r[0].etype == 'O') {
            this.industry_type = "Others";
          }
          else if (r[0].etype == 'U') {
            this.industry_type = "Unknown";
          }
          this.entity_name = r[0].name

        }
        catch (e) {
          console.log("error", e)

        }
      })
  }





}

export class MyDataSource extends DataSource<any[]> {

  constructor(private subject: BehaviorSubject<any[]>) {
    super();
  }
  connect(): Observable<any[]> {
    return this.subject.asObservable();
  }
  disconnect(): void {

  }

}
